angular.module('backstage.controllers.brandedApps', [])
    .controller('appsListCtrl', require('./appsListCtrl'))
    .controller('brandedAppsI81NFieldEditorCtrl', require('./brandedAppsI81NFieldEditorCtrl'))
    .controller('editAppCtrl', require('./editAppCtrl'))
    .controller('publishingAccountEditCtrl', require('./publishingAccountEditCtrl'))
    .controller('publishingAccountsListCtrl', require('./publishingAccountsListCtrl'))
    .controller('publishingRequestsListCtrl', require('./publishingRequestsListCtrl'))
    .controller('pushCertificatesListCtrl', require('./pushCertificatesListCtrl'))
    .controller('eventsFieldCtrl', require('./eventsFieldCtrl'));
